<mat-icon
  class="offering-icon"
  tooltipClass="product-tooltip"
  [svgIcon]="iconName"
  [uiTooltip]="text | translate | stripHtml"
/>
